import React from 'react';

export default function AnimatedTitle() {
  return (
    <div className="animated-title__wrapper">
      <div className="animated-title page-auth__animated-title">
        <div className="animated-title__background-wrapper">
          <img class="animated-title__background" src="/Content/images/bg/video-bg.gif" alt="" />
        </div>
        <div className="animated-title__text">
          <svg
            id="overlay"
            width="500"
            height="52"
            viewBox="0 0 500 52"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <mask id="mymask">
                <rect width="100%" height="100%" fill="#fff" x="0" y="0" />
                <text x="0" y="80%" textAnchor="left" fontSize="47px">АДВОКАТЫ БРЕНДА</text>
              </mask>
            </defs>

            <rect fill="#fff" width="550" height="52" mask="url(#mymask)" />
          </svg>
        </div>
      </div>
    </div>
  );
}
